import { createMuiTheme } from '@material-ui/core/styles';

const font = "'Noto Sans', sans-serif";

const theme  = createMuiTheme({
    typography: {
    fontFamily: font
  }
});

// all styles
const styles = {
  button: {
    height: 56,
    color: 'white',
    backgroundColor: '#3A7294'
  },
  h1: {
    marginBottom: '25px',
    color: '#3A7294'
  }
};

export {
  theme,
  styles
}



// WEBPACK FOOTER //
// ./src/js/helpers/mui.js